<template>
  <Card class="DealFilterInitial">
    <div class="row">
      <div class="col-12">
        <FormItemGroup>
          <FilterCustomerType />
        </FormItemGroup>
      </div>
      <router-link
        to="/deals"
        class="DealFilterInitial__searchButton"
      >
        <el-button type="primary">
          {{ $t('searchButton') }}
        </el-button>
      </router-link>
    </div>
  </Card>
</template>

<script>
import Vue from 'vue';
import { Button } from 'element-ui';
// Card
import Card from '@/components/Card.vue';
// Form item
import FormItemGroup from '@/components/formItem/Group.vue';
import FilterCustomerType from '@/components/filter/CustomerType.vue';

Vue.use(Button);

export default {
  name: 'DealFilterInitial',
  components: {
    Card,
    FormItemGroup,
    FilterCustomerType,
  },
  computed: {
    customerType() {
      return this.$store.state.filter.activeFilters.customerType;
    },
  },
};
</script>

<style scoped lang="scss">
.DealFilterInitial {
  background: rgba(255,255,255,0.85);
  width: 100%;
}
.DealFilterInitial__searchButton {
  float: right;
  margin-top: 5px;
}
.DealFilterInitial {
  border-bottom: 0;
}
.DealFilterInitial__searchButton {
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}
@include media-lg() {
  .DealFilterInitial {
    width: 400px;
  }
}
</style>
